<template>
  <div
    v-line-clamp="1"
    class="color-nobel e2e-product-size text-lowercase"
    :class="fontSize"
  >
    {{ `${formatUnitSize(size, baseSize, uom)} ` }}
  </div>
</template>
<script>
export default {
  name: "UnitSizeDisplay",
  computed: {
    fontSize() {
      return this.small ? "font-size-xs" : "";
    },
  },
  methods: {
    formatUnitSize(size, base, unit) {
      return size ? size : base && unit ? base + " " + unit : "";
    },
  },
  props: { baseSize: String, size: String, small: Boolean, uom: String },
};
</script>
